import script from "./SniffDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./SniffDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./SniffDrawer.vue?vue&type=style&index=0&id=5c15095d&lang=scss"

const __exports__ = script;

export default __exports__